/**
 * Extracts the first EVSE id from a pool QR-code `ids` query param
 * (a comma-separated list, e.g. "FR*USC*EAU*OLI1*01*4*1,FR*USC*EAU*OLI1*01*4*2").
 * Returns null when the input yields no usable id.
 */
export const getFirstPoolId = (ids: string): string | null => {
	const first = ids.split(",")[0]?.trim();

	return first ? first : null;
};
